module.exports = __webpack_public_path__ + "assets/images/3RhclKdA23.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/index/map.png
// module id = 2181
// module chunks = 0